import { Settings, Logout, Home, Dns, Map, ListAlt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../hooks/use-auth';
import { ROUTES } from '../../../router/routes-definitions';
import { useLayoutStore } from '../../../store/layout';

export const useLayoutSideDrawer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleDrawerClose = useLayoutStore((s) => s.handleDrawerClose);
  const { keycloakLogout } = useAuth();

  const handleDrawerItemClick = (action: () => void) => {
    action();
    handleDrawerClose();
  };

  const menuItems = [
    {
      icon: Home,
      label: t('navigation.home'),
      onClick: () => handleDrawerItemClick(() => navigate(ROUTES.HOME)),
    },
    {
      icon: Dns,
      label: t('navigation.clusters'),
      onClick: () => handleDrawerItemClick(() => navigate(ROUTES.CLUSTERS)),
    },
    {
      icon: Map,
      label: t('navigation.map'),
      onClick: () => handleDrawerItemClick(() => navigate(ROUTES.MAP)),
    },
    {
      icon: Settings,
      label: t('navigation.settings'),
      onClick: () => handleDrawerItemClick(() => navigate(ROUTES.SETTINGS)),
    },
    {
      icon: ListAlt,
      label: t('navigation.documents'),
      onClick: () => handleDrawerItemClick(() => navigate(ROUTES.DOCUMENTS)),
    },
    {
      icon: Logout,
      label: t('navigation.logout'),
      onClick: () => handleDrawerItemClick(() => keycloakLogout()),
    },
  ];

  return {
    menuItems,
  };
};
